import { render, staticRenderFns } from "./data15.vue?vue&type=template&id=077e3d28&scoped=true&"
import script from "./data15.vue?vue&type=script&lang=js&"
export * from "./data15.vue?vue&type=script&lang=js&"
import style1 from "./data15.vue?vue&type=style&index=1&id=077e3d28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e3d28",
  null
  
)

export default component.exports